<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group label="Field" :label-cols="3">
          <b-form-input
            type="text"
            v-model="form.identifier"
            placeholder="Enter Project Name"
            :state="!$v.form.identifier.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Event Code" :label-cols="3">
          <b-form-input
            type="text"
            v-model="form.event_code"
            placeholder="Enter Project Event Code (optional)"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "TissueFieldFormGroups",
  mixins: [validationMixin, ToastNotifications],
  props: ["submission", "index"],
  data() {
    return {
      form: {
        identifier: null,
        event_code: null
      }
    };
  },
  validations: {
    form: {
      identifier: { required }
    }
  },
  methods: {},
  watch: {
    form: {
      handler() {
        this.$emit("onFieldChange", this.form);
      },
      deep: true
    },
    submission: {
      handler(value) {
        this.form.identifier = value.identifier;
        this.form.event_code = value.event_code;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
